const s = {
  name: "User",
  dimensions: { width: 36, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 36 40" style="enable-background:new 0 0 36 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M18,0c-4.4,0-8,3.6-8,8c0,4.4,3.6,8,8,8s8-3.6,8-8C26,3.6,22.4,0,18,0z M12,8c0-3.3,2.7-6,6-6s6,2.7,6,6
			s-2.7,6-6,6S12,11.3,12,8z"/>
		<path class="st0" d="M11,18C4.9,18,0,22.9,0,29v11h2V29c0-5,4-9,9-9h14c5,0,9,4,9,9v11h2V29c0-6.1-4.9-11-11-11H11z"/>
		<path class="st0" d="M6,40V30h2v10H6z"/>
		<path class="st0" d="M28,30v10h2V30H28z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as User
};
